import { render, staticRenderFns } from "./CreateOptionGroupModal.vue?vue&type=template&id=d8889e7e&"
import script from "./CreateOptionGroupModal.vue?vue&type=script&lang=ts&"
export * from "./CreateOptionGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports